import type { SVGProps } from 'react';
const SvgDoubleArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#double_arrow_svg__a)">
      <path d="M15.5 5H11l5 7-5 7h4.5l5-7-5-7Z" />
      <path d="M8.5 5H4l5 7-5 7h4.5l5-7-5-7Z" />
    </g>
    <defs>
      <clipPath id="double_arrow_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDoubleArrow;
